/* eslint-disable */

import React, { useState, useEffect, useMemo, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import AuthContext from "../../contexts/AuthProvider";
import { toast } from "react-toastify";
import { useImmer } from "use-immer";
import { ThreeDots } from "react-loader-spinner";
import fileDownload from "js-file-download";
import cx from "classnames";
import {
  getKpiTypeTranslation,
  getKpiSubtypeTranslation,
} from "../../utils/kpitranslationUtils";

// Material-UI Components
import { makeStyles } from "@material-ui/core/styles";
import {
  Tabs,
  Tab,
  Typography,
  Paper,
  Tooltip,
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";


// Material-UI Icons
import {
  CloudUpload as CloudUploadIcon,
  GetApp as DownloadIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  AddCircle,
  Save as SaveIcon,
  CheckCircle,
  ErrorOutline,
  Assessment as AssessmentIcon,
  BorderTop,
  Search as SearchIcon,
  Info as InfoIcon,
} from "@material-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { Sort } from "@material-ui/icons";

// Core Components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import Card from "../../components/Card/Card.js";
import CardBody from "../../components/Card/CardBody.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import Button from "../../components/CustomButtons/Button";
import Tippy from "@tippyjs/react";
import InitiativesConsolidatedGantt from "../InitiativesProgram/InitiativesConsolidatedGantt.js";

// Services
import { client } from "../../services/axiosClient";

// Styles
import {
  cardTitle,
  grayColor,
  whiteColor,
  successColor,
  dangerColor,
  warningColor,
} from "../../assets/jss/material-dashboard-pro-react.js";

export default function CentralUploads() {
  const { t } = useTranslation();
  const { userDetails } = useContext(AuthContext);
  const props = { clientColor: userDetails.implementation_color || "#000" };

  const useStyles = makeStyles((theme) => ({

    root: { padding: theme.spacing(1), marginTop: "0px" },
    cardIconTitle: { ...cardTitle, marginTop: "15px", marginBottom: "0px" },
    tabsRoot: {
      backgroundColor: "#f5f5f5",
      borderRadius: "4px",
      minHeight: "42px",
      height: "42px",
      "& .MuiTabs-flexContainer": { minHeight: "42px", height: "42px" },
    },
    tabRoot: {
      margin: 0,
      padding: "0 16px",
      fontSize: "0.7rem",
      fontWeight: 400,
      color: "black",
      textTransform: "uppercase",
      "&:hover": { color: (props) => props.clientColor, opacity: 1 },
      "&.Mui-selected": { color: "black", fontWeight: 500 },
      "&:focus": { color: "black" },
    },
    indicator: { backgroundColor: (props) => props.clientColor, height: "2px" },
    kpiBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start", 
      backgroundColor: "#f9f9f9",
      border: `1px solid ${grayColor[11]}`,
      borderLeft: (props) => `5px solid ${props.clientColor}`, 
      borderRadius: "8px",
      height: "100px",
      position: "relative",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      padding: "0 16px",
      gap: "16px", 
      "&:hover": {
        transform: "scale(1.02)", 
        boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
      },
    },
    kpiBoxIcon: {
      fontSize: "40px", 
      color: (props) => props.clientColor,
      opacity: 0.7,
    },
    kpiTitleBox: {
      fontSize: "1rem",
      fontWeight: "500",
      textAlign: "left", 
    },
    drawerPaper: {
      width: "700px",
      maxHeight: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2),
    },
    drawerHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${grayColor[5]}`,
    },
    tableContainer: { marginTop: theme.spacing(2), maxHeight: "70vh" },
    tableHeadCell: {
      fontWeight: "bold",
      backgroundColor: grayColor[12],
      position: "sticky",
      top: 0,
      zIndex: 1,
    },
    stickyColumn: {
      position: "sticky",
      left: 0,
      // AUMENTE O Z-INDEX PARA 4
      zIndex: 4,
      backgroundColor: `${whiteColor} !important`,
      borderRight: `1px solid ${grayColor[11]}`,
      width: "250px",
      minWidth: "250px",
    },
    stickyHeaderCell: {
      position: "sticky",
      left: 0,
      // AUMENTE O Z-INDEX PARA 5 (MAIS ALTO DE TODOS)
      zIndex: 5,
      backgroundColor: `${grayColor[12]} !important`,
      borderRight: `1px solid ${grayColor[11]}`,
      width: "250px",
      minWidth: "250px",
    },
    stickyColumnSecond: {
      position: "sticky",
      // MANTENHA O Z-INDEX EM 2
      zIndex: 2,
      left: "250px",
      backgroundColor: `${whiteColor} !important`,
      borderRight: `1px solid ${grayColor[11]}`,
      width: "250px",
      minWidth: "250px",
    },
    stickyHeaderCellSecond: {
      position: "sticky",
      // MANTENHA O Z-INDEX EM 3
      zIndex: 3,
      left: "250px",
      backgroundColor: `${grayColor[12]} !important`,
      borderRight: `1px solid ${grayColor[11]}`,
      width: "250px",
      minWidth: "250px",
    },
    textFieldRoot: {
      "& .MuiInput-underline:before": { borderBottom: "1px solid #ccc" },
      "&:hover .MuiInput-underline:not(.Mui-disabled):before": {
        borderBottom: (props) => `2px solid ${props.clientColor}`,
      },
      "& .MuiInput-underline:after": {
        borderBottom: (props) => `2px solid ${props.clientColor}`,
      },
    },
    inputText: {
      color: "#3C4858",
      "&:focus": { color: "#3C4858" },
    },
    labelText: {
      color: "#666",
      "&.Mui-focused": { color: "#666" },
    },
    searchIcon: {
      color: grayColor[1],
    },

    inlineValueInput: {
      width: "120px",
      "& .MuiOutlinedInput-input": { padding: "8px", textAlign: "center" },
    },
    sectionHeader: {
      textAlign: "center",
      padding: "10px 0",
      fontWeight: 400,
      fontSize: "14px",
      backgroundColor: "#FAFAFA",
      color: "#888888",
      margin: "20px 0 10px 0",
      borderRadius: "5px",
      border: `1px solid ${grayColor[11]}`, // Borda geral sutil
      borderBottom: (props) => `1px solid ${props.clientColor}`, // Apenas a inferior é destacada
    },
    valueCell: {
      minWidth: "260px",
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
    },
    valueInputContainer: { display: "flex", gap: "8px", alignItems: "center" },
    actionButtonsBar: {
      padding: "16px",
      borderTop: `1px solid ${grayColor[10]}`,
      borderBottom: `1px solid ${grayColor[10]}`,
      backgroundColor: "#fdfdfd",
      display: "flex",
      justifyContent: "space-between",
      gap: "20px",
      alignItems: "center",
    },
    actionCell: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "2px",
      minWidth: "120px",
    },
    uploadedFileName: {
      fontStyle: "italic",
      color: grayColor[1],
      marginRight: "10px",
      maxWidth: "200px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    uploadStatusContainer: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
      padding: "0 16px",
      height: "0",
      opacity: "0",
      transition: "height 0.3s ease, opacity 0.3s ease",
      overflow: "hidden",
    },
    uploadStatusVisible: { height: "24px", opacity: "1" },
    statusIndicator: {
      display: "flex",
      alignItems: "center",
      fontSize: "0.8rem",
      color: grayColor[1],
      "& svg": { marginRight: theme.spacing(1) },
    },
    statusSuccess: { color: successColor[0] },
    statusError: { color: dangerColor[0] },
    attention: {
      backgroundColor: `${warningColor[0]} !important`,
      animation: "$attention 2.5s ease-in-out infinite",
    },
    "@keyframes attention": {
      "0%, 100%": { transform: "scale(1)" },
      "5%, 15%": { transform: "scale(1.1) rotate(-3deg)" },
      "10%, 20%": { transform: "scale(1.1) rotate(3deg)" },
      "25%": { transform: "scale(1.1) rotate(0deg)" },
    },
      ganttMaster: {
        maxHeight: 450,
        overflowY: "auto",
        overflowX: "auto", // scroll X para todo o conjunto
        position: "relative",
        border: "1px solid #ccc",
        fontFamily: "Roboto",
      },
      ganttTable: {
        background: "#fff",
        zIndex: 3,
        borderRight: "1px solid #ddd",
        minWidth: 300,
      },
      ganttTableHeader: {
        position: "sticky", // Fixa o cabeçalho no topo ao rolar verticalmente
        top: 0,
        zIndex: 5,
        backgroundColor: "#f1f1f1",
      },
      ganttTableColumns: {
        padding: "8px",
        borderRight: "1px solid #ddd",
        textAlign: "left",
        fontWeight: 500,
        fontSize: "13px",
        fontFamily: "Roboto",
        cursor: "pointer",
      },
      ganttTableBody1st: {
        padding: "4px 8px",
        borderRight: "1px solid #ddd",
        cursor: "pointer",
        textAlign: "left",
        fontWeight: 400,
        fontSize: "11px",
        fontFamily: "Roboto",
        color: "#333",
      },
      ganttTableBody: {
        padding: "4px 8px",
        borderRight: "1px solid #ddd",
        textAlign: "center",
        fontWeight: 400,
        fontSize: "11px",
        fontFamily: "Roboto",
        color: "#333",
      },
      ganttTimeline: {
        position: "sticky",
        top: 0,
        zIndex: 5,
        display: "flex",
        backgroundColor: "#f0f0f0",
        borderBottom: "1px solid #ddd",
        fontSize: "13px",
        fontWeight: 500,
      },
      ganttTimelineFormat: {
        borderRight: "1px solid #eee",
        textAlign: "center",
        fontSize: "10px",
        padding: "2px",
        height: "37px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      toggleGanttDataFilter:{
        paddingTop: -7, 
        paddingBottom: -7, 
        fontSize:"9px", 
        border: "none",
        borderRadius: "0px",
        color: "#3C4858",
      },
  }));

  const classes = useStyles(props);

  const { clientColor } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [kpiGroups, setKpiGroups] = useImmer({
    centralized: {},
    initiative: [],
  });
  const [initiativeSearch, setInitiativeSearch] = useState("");
  const fileInputRef = useRef(null);
  const planFileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileValidationStatus, setFileValidationStatus] = useState({
    isValid: false,
    message: "",
    isChecked: false,
  });
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    start: new Date().toISOString().substring(0, 7),
    end: new Date(new Date().setMonth(new Date().getMonth() + 5))
      .toISOString()
      .substring(0, 7),
  });
  const [initiativeValues, setInitiativeValues] = useImmer({});
  const [tableMonths, setTableMonths] = useImmer([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedKpi, setSelectedKpi] = useState(null);
  const [isDrawerLoading, setIsDrawerLoading] = useState(false);
  const [centralKpiRows, setCentralKpiRows] = useImmer([]);

  // States for implementation Integration
  const [planData, setPlanData] = useState({
    configs: [], 
  });
  const [isPlanLoading, setIsPlanLoading] = useState(true);
  const [selectedPlanFile, setSelectedPlanFile] = useState(null);
  const [isPlanProcessing, setIsPlanProcessing] = useState(false);

  // load initiatives
  const [initiatives, setInitiatives] = useState([]);

  const fetchIntegrationConfigs = async () => {
    // We'll create a simple view for this
    const response = await client.post("/api/list_integration_configs/");
    return response.data.configs || [];
  }

  useEffect(() => {
    let isMounted = true; // Evita race conditions se o componente for desmontado

    const loadAllData = async () => {
      if (!isMounted) return;
      
      console.log("[CentralUploads] Starting data load...");
      setIsLoading(true);
      setHasError(false);
      setErrorMessage("");

      try {
        // Usaremos Promise.all para disparar todas as chamadas de API em paralelo.
        console.log("[CentralUploads] Making parallel API calls...");
        const [
          configsResponse,
          kpiDataResponse,
          initiativesResponse
        ] = await Promise.all([
          client.post("/api/list_integration_configs/"),
          client.post("/api/central_upload_data/", { action: "list" }),
          client.post("/api/initiatives_list_board/", { action: "list" })
        ]);

        if (!isMounted) return; // Verifica se o componente ainda está montado

        console.log("[CentralUploads] API calls completed. Processing responses...");

        // --- Processar Configurações de Integração ---
        if (configsResponse?.data?.success) {
          setPlanData(prev => ({ ...prev, configs: configsResponse.data.configs || [] }));
          console.log("[CentralUploads] Integration configs loaded successfully");
        } else {
          console.warn("[CentralUploads] Failed to load integration configs:", configsResponse?.data);
        }

        // --- Processar Dados de KPIs ---
        if (kpiDataResponse?.data?.success) {
          const data = kpiDataResponse.data.data;
          if (data) {
            const centralizedGrouped = (data.centralized_kpis || []).reduce(
              (acc, kpi) => {
                const subtype = kpi.subtype || "uncategorized";
                if (!acc[subtype]) acc[subtype] = [];
                acc[subtype].push(kpi);
                return acc;
              },
              {}
            );
            
            setKpiGroups({
              centralized: centralizedGrouped,
              initiative: data.initiative_kpis || [],
            });

            console.log("[CentralUploads] KPI data processed successfully");

            // Lógica para buscar os valores de iniciativa (apenas se ainda montado)
            if (isMounted) {
              const allInitiativeKpiIds = (data.initiative_kpis || []).flatMap(
                (kpi) => (kpi.linked_initiatives || []).map((link) => link.initiative_kpi_id)
              );
              
              if (allInitiativeKpiIds.length > 0) {
                console.log("[CentralUploads] Loading initiative values...");
                const valuesResponse = await client.post("/api/initiative_values_bulk/", {
                  initiative_kpi_ids: allInitiativeKpiIds,
                });
                
                if (isMounted && valuesResponse?.data?.success) {
                  setInitiativeValues(valuesResponse.data.values || {});
                  const allMonths = new Set();
                  Object.values(valuesResponse.data.values || {}).forEach((kpiData) =>
                    Object.keys(kpiData).forEach((month) => allMonths.add(month))
                  );
                  const sortedMonths = Array.from(allMonths).sort();
                  setTableMonths(sortedMonths.length > 0 ? sortedMonths : generateDefaultMonths());
                  console.log("[CentralUploads] Initiative values loaded successfully");
                }
              } else {
                setTableMonths(generateDefaultMonths());
                console.log("[CentralUploads] No initiative KPIs found, using default months");
              }
            }
          } else {
            console.warn("[CentralUploads] KPI data response missing data field");
          }
        } else {
          console.warn("[CentralUploads] Failed to load KPI data:", kpiDataResponse?.data);
        }
        
        // --- Processar Dados de Iniciativas para o Gantt ---
        if (initiativesResponse?.data?.success) {
          setInitiatives(initiativesResponse.data.initiatives || []);
          console.log("[CentralUploads] Initiatives loaded successfully for Gantt");
        } else {
          console.warn("[CentralUploads] Failed to load initiatives for Gantt:", initiativesResponse?.data);
        }

        console.log("[CentralUploads] Data load completed successfully");

      } catch (error) {
        if (!isMounted) return;
        
        console.error("[CentralUploads] Error loading page data:", error);
        const errorMsg = error.response?.data?.message || error.message || t("centralUploads.errors.load_failed");
        setHasError(true);
        setErrorMessage(errorMsg);
        toast.error(errorMsg);
      } finally {
        if (isMounted) {
          setIsLoading(false);
          console.log("[CentralUploads] Loading state set to false");
        }
      }
    };

    loadAllData();

    // Cleanup function para evitar race conditions
    return () => {
      isMounted = false;
      console.log("[CentralUploads] Component unmounted, canceling pending operations");
    };
  }, [t]); // Removemos setters das dependências para evitar loops

  useEffect(() => {
    setUploadedFile(null);
    setFileValidationStatus({ isValid: false, message: "", isChecked: false });
  }, [activeTab]);

  const generateDefaultMonths = () => {
    const months = [];
    const d = new Date();
    d.setMonth(d.getMonth() - 3);
    for (let i = 0; i < 6; i++) {
      months.push(
        new Date(d.setMonth(d.getMonth() + 1)).toISOString().substring(0, 7)
      );
    }
    return months;
  };


  useEffect(() => {
    let isMounted = true;

    const fetchPlanData = async () => {
      if (!isMounted) return;
      
      console.log("[CentralUploads] Loading plan data...");
      setIsPlanLoading(true);
      
      try {
        const response = await client.post("/api/implementation-plan-data/", {});
        
        if (!isMounted) return;
        
        if (response?.data?.success) {
          setPlanData({
            integrations: response.data.data?.active_integrations || [],
            initiatives: response.data.data?.gantt_initiatives || [],
          });
          console.log("[CentralUploads] Plan data loaded successfully");
        } else {
          console.warn("[CentralUploads] Plan data load failed:", response?.data);
          toast.error(t("centralUploads.errors.load_plan_failed"));
        }
      } catch (error) {
        if (!isMounted) return;
        
        console.error("[CentralUploads] Error fetching implementation plan data:", error);
        toast.error(t("centralUploads.errors.load_plan_failed"));
      } finally {
        if (isMounted) {
          setIsPlanLoading(false);
          console.log("[CentralUploads] Plan loading state set to false");
        }
      }
    };
    
    fetchPlanData();

    return () => {
      isMounted = false;
    };
  }, [t]);

  // Handlers for implementation plan
  const handlePlanFileSelect = (event) => {
    const file = event.target.files[0];
    if (planFileInputRef.current) planFileInputRef.current.value = "";
    if (file && (file.name.endsWith(".xlsx") || file.name.endsWith(".mpp"))) {
      setSelectedPlanFile(file);
    } else if (file) {
      toast.error(t("centralUploads.errors.invalid_plan_file_type"));
    }
  };

  // Handle validation errors with detailed user-friendly messages
  const handleValidationErrors = (validationErrors) => {
    // Only show detailed error messages, not a generic one
    
    if (validationErrors.errors && validationErrors.errors.length > 0) {
      validationErrors.errors.forEach((error, index) => {
        let errorMessage = "";
        let details = "";
        
        switch (error.error_type) {
          case "missing_required_columns":
            errorMessage = t("centralUploads.errors.missing_required_columns");
            if (error.details?.missing_columns) {
              details = `: ${error.details.missing_columns.join(", ")}`;
            }
            break;
            
          case "invalid_date_format":
            errorMessage = t("centralUploads.errors.invalid_date_format");
            if (error.details?.column) {
              details = ` em "${error.details.column}"`;
              if (error.details?.samples) {
                details += `. Exemplos: ${error.details.samples.map(s => s.value).join(", ")}`;
              }
              if (error.details?.help) {
                details += `. ${error.details.help}`;
              }
            }
            break;
            
          case "invalid_uuid_format":
            errorMessage = t("centralUploads.errors.invalid_uuid_format");
            if (error.details?.count) {
              details = ` (${error.details.count} ID(s))`;
            }
            break;
            
          case "invalid_choice_values":
            errorMessage = t("centralUploads.errors.invalid_choice_values");
            if (error.details?.column) {
              details = ` em "${error.details.column}"`;
            }
            break;
            
          case "empty_required_values":
            errorMessage = t("centralUploads.errors.empty_required_values");
            if (error.details?.column) {
              details = ` em "${error.details.column}"`;
            }
            break;
            
          default:
            errorMessage = error.message || t("centralUploads.errors.validation_failed_generic");
        }
        
        // Show each error as a separate toast with a small delay
        setTimeout(() => {
          toast.error(`${errorMessage}${details}`, {
            autoClose: 8000, // Longer duration for detailed messages
            position: "top-right"
          });
        }, index * 500); // Stagger the toasts
      });
    }
    
    // Show warnings if any (less critical) 
    // Note: We skip "initiatives_not_found" and "file_structure_info" as they are informational only
    if (validationErrors.warnings && validationErrors.warnings.length > 0) {
      setTimeout(() => {
        validationErrors.warnings.forEach((warning) => {
          // Only show critical warnings, skip informational ones
          if (warning.error_type === "database_check_failed") {
            toast.warn(warning.message, {
              autoClose: 6000
            });
          }
          // Skip: initiatives_not_found, initiatives_found, file_structure_info
        });
      }, validationErrors.errors?.length * 500 || 0);
    }
  };

  const handleProcessPlanFile = async (integrationConfig) => {
    if (!selectedPlanFile) {
      toast.warn(t("centralUploads.errors.no_file_selected"));
      return;
    }

    setIsPlanProcessing(true);
    const formData = new FormData();
    formData.append("file", selectedPlanFile);
    // Passamos o NOME da configuração, que é o que a backend API agora espera
    formData.append("config_name", integrationConfig.name); 

    try {
      const response = await client.post("/api/integrations/process-and-save/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      
      if (response.data.success) {
        toast.success(t("centralUploads.messages.integration_success") || "Integração realizada com sucesso!");
        
        // Show statistics in console
        if (response.data.statistics) {
          console.log("--- Integration Statistics ---");
          console.log(`Created: ${response.data.statistics.created}`);
          console.log(`Updated: ${response.data.statistics.updated}`);
          console.log(`Errors: ${response.data.statistics.errors}`);
          console.log(`Total Processed: ${response.data.statistics.total_processed}`);
          console.log("-----------------------------");
        }

        setSelectedPlanFile(null); // Limpa o arquivo após o sucesso
      } else {
        // Handle validation errors specifically
        if (response.data.validation_errors) {
          handleValidationErrors(response.data.validation_errors);
        } else {
          toast.error(response.data.error || t("centralUploads.errors.upload_failed"));
        }
      }
    } catch (error) {
      // Handle validation errors from error response
      if (error.response?.data?.validation_errors) {
        handleValidationErrors(error.response.data.validation_errors);
      } else {
        toast.error(error.response?.data?.error || t("centralUploads.errors.upload_failed"));
      }
    } finally {
      setIsPlanProcessing(false);
    }
  };

  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  const handleDateRangeChange = (field, value) =>
    setDateRange((prev) => ({ ...prev, [field]: value }));
  const handleOpenDateModal = () => setIsDateModalOpen(true);
  const handleCloseDateModal = () => setIsDateModalOpen(false);

  const handleKpiBoxClick = async (kpi) => {
    setSelectedKpi(kpi);
    setDrawerOpen(true);
    setIsDrawerLoading(true);
    try {
      const response = await client.post("/api/individual_kpi_value/", {
        action: "list",
        kpi_type: "centralized",
        kpi_id: kpi.id,
      });
      if (response.data.success) {
        setCentralKpiRows(
          response.data.data.map((item) => ({ ...item, id: item.period }))
        );
      }
    } catch (error) {
      toast.error(t("centralUploads.errors.load_kpi_data_failed"));
    } finally {
      setIsDrawerLoading(false);
    }
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedKpi(null);
    setCentralKpiRows([]);
  };

  const handleAddDrawerRow = () =>
    setCentralKpiRows((draft) => {
      draft.unshift({
        id: Date.now(),
        period: "",
        target: null,
        actual: null,
        isNew: true,
      });
    });

  const handleDrawerCellChange = (id, field, value) =>
    setCentralKpiRows((draft) => {
      const row = draft.find((r) => r.id === id);
      if (row) row[field] = value;
    });

  const handleSaveDrawerRow = async (row) => {
    if (!row.period) {
      toast.warn(t("centralUploads.errors.period_required"));
      return;
    }
    toast.promise(
      client.post("/api/individual_kpi_value/", {
        action: "save",
        kpi_type: "centralized",
        kpi_id: selectedKpi.id,
        date: row.period,
        target: row.target,
        actual: row.actual,
      }),
      {
        pending: t("actions.saving"),
        success: t("actions.save_success"),
        error: t("actions.save_error"),
      }
    );
  };

  const handleDeleteDrawerRow = async (row) => {
    setCentralKpiRows((draft) => draft.filter((r) => r.id !== row.id));
    if (!row.isNew) {
      toast.promise(
        client.post("/api/individual_kpi_value/", {
          action: "delete",
          kpi_type: "centralized",
          kpi_id: selectedKpi.id,
          date: row.period,
        }),
        {
          pending: t("actions.deleting"),
          success: t("actions.delete_success"),
          error: t("actions.delete_error"),
        }
      );
    }
  };

  const handleDownloadTemplate = async () => {
    const type = activeTab === 0 ? "centralized" : "initiative";
    toast.info(t("centralUploads.messages.generating_template"));
    try {
      const response = await client.post(
        "/api/central_upload_template/",
        { type, start_date: dateRange.start, end_date: dateRange.end },
        { responseType: "blob" }
      );
      const filename =
        type === "centralized"
          ? "Template_Centralized_KPIs.xlsx"
          : "Template_Initiative_KPIs.xlsx";
      fileDownload(response.data, filename);
      handleCloseDateModal();
    } catch (error) {
      toast.error(t("centralUploads.errors.template_download_failed"));
    }
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (!file) {
      setUploadedFile(null);
      setFileValidationStatus({
        isValid: false,
        message: "",
        isChecked: false,
      });
      return;
    }
    if (!file.name.endsWith(".xlsx")) {
      toast.error(t("centralUploads.errors.invalid_file_type"));
      setUploadedFile(null);
      setFileValidationStatus({
        isValid: false,
        message: t("centralUploads.errors.invalid_file_type"),
        isChecked: true,
      });
      return;
    }

    setUploadedFile(file);
    setIsValidating(true);
    setFileValidationStatus({
      isValid: false,
      message: t("centralUploads.messages.validating_file"),
      isChecked: false,
    });

    const type = activeTab === 0 ? "centralized" : "initiative";
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);

    try {
      const response = await client.post(
        "/api/validate_upload_file/",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.data.success) {
        setFileValidationStatus({
          isValid: true,
          message: t("centralUploads.messages.validation_success"),
          isChecked: true,
        });
      } else {
        const errorMessage =
          response.data.message ||
          t("centralUploads.errors.validation_failed_generic");
        setFileValidationStatus({
          isValid: false,
          message: errorMessage,
          isChecked: true,
        });
      }
    } catch (error) {
      const message =
        error.response?.data?.message ||
        t("centralUploads.errors.validation_failed");
      setFileValidationStatus({
        isValid: false,
        message: message,
        isChecked: true,
      });
    } finally {
      setIsValidating(false);
    }
  };

  const handleProcessFile = () => {
    if (!uploadedFile) {
      toast.warn(t("centralUploads.errors.no_file_selected"));
      return;
    }
    if (!fileValidationStatus.isValid) {
      toast.error(
        fileValidationStatus.message ||
          t("centralUploads.errors.file_not_validated")
      );
      return;
    }
    setIsProcessing(true);
    const type = activeTab === 0 ? "centralized" : "initiative";
    const formData = new FormData();
    formData.append("file", uploadedFile);
    formData.append("type", type);

    toast.promise(
      client.post("/api/central_upload_process/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
      {
        pending: t("centralUploads.messages.processing_file"),
        success: {
          render: ({ data }) => {
            setIsProcessing(false);
            setUploadedFile(null);
            setFileValidationStatus({
              isValid: false,
              message: "",
              isChecked: false,
            });
            return data.data.message;
          },
        },
        error: {
          render: ({ data }) => {
            setIsProcessing(false);
            // Prioritize the specific 'message' from the backend, then 'error', then a generic fallback.
            const errorMessage =
              data.response?.data?.message ||
              data.response?.data?.error ||
              t("centralUploads.errors.upload_failed");
            setFileValidationStatus({
              isValid: false,
              message: errorMessage,
              isChecked: true,
            });
            return errorMessage;
          },
        },
      }
    );
  };

  const handleInitiativeTableCellChange = (ikpi_id, month, field, value) => {
    setInitiativeValues((draft) => {
      const idStr = String(ikpi_id);
      if (!draft[idStr]) draft[idStr] = {};
      if (!draft[idStr][month])
        draft[idStr][month] = { target: null, actual: null };
      draft[idStr][month][field] = value;
    });
  };

  const handleSaveInitiativeMonthValue = (ikpi_id, month) => {
    const values = initiativeValues[String(ikpi_id)]?.[month];
    toast.promise(
      client.post("/api/individual_kpi_value/", {
        action: "save",
        kpi_type: "initiative",
        initiative_kpi_id: ikpi_id,
        date: month,
        target: values?.target,
        actual: values?.actual,
      }),
      {
        pending: t("actions.saving"),
        success: t("actions.save_success"),
        error: t("actions.save_error"),
      }
    );
  };

  const handleDeleteInitiativeMonthValue = (ikpi_id, month) => {
    setInitiativeValues((draft) => {
      if (draft[String(ikpi_id)] && draft[String(ikpi_id)][month]) {
        delete draft[String(ikpi_id)][month];
      }
    });
    toast.promise(
      client.post("/api/individual_kpi_value/", {
        action: "delete",
        kpi_type: "initiative",
        initiative_kpi_id: ikpi_id,
        date: month,
      }),
      {
        pending: t("actions.deleting"),
        success: t("actions.delete_success"),
        error: t("actions.delete_error"),
      }
    );
  };

  const flatInitiativeKpiData = useMemo(() => {
    const flatData = [];
    (kpiGroups.initiative || []).forEach((kpi) => {
      (kpi.linked_initiatives || []).forEach((link) => {
        flatData.push({
          ...link,
          kpi_id: kpi.id,
          kpi_name: kpi.title,
          kpi_type: kpi.type,
          kpi_subtype: kpi.subtype,
        });
      });
    });
    return flatData;
  }, [kpiGroups.initiative]);

  const filteredInitiativeData = useMemo(() => {
    if (!flatInitiativeKpiData) return [];
    let data = flatInitiativeKpiData.filter(
      (row) =>
        !initiativeSearch ||
        row.initiative_name
          .toLowerCase()
          .includes(initiativeSearch.toLowerCase())
    );
    data.sort(
      (a, b) =>
        a.initiative_name.localeCompare(b.initiative_name) ||
        a.kpi_name.localeCompare(b.kpi_name)
    );
    return data;
  }, [flatInitiativeKpiData, initiativeSearch]);

  const renderActionButtons = () => (
    <>
      <div className={classes.actionButtonsBar}>
        <Typography variant="body2" style={{ color: grayColor[2] }}>
          {t("centralUploads.instructions.bulk_upload_area")}
        </Typography>

        {/* Action Buttons Group on the Right */}
        <Box display="flex" alignItems="center" gap="300px">
          {uploadedFile && (
            <Box display="flex" alignItems="center">
              <Typography
                variant="body2"
                className={classes.uploadedFileName}
                title={uploadedFile.name}
              >
                {uploadedFile.name}
              </Typography>
              <IconButton
                size="small"
                onClick={() => {
                  setUploadedFile(null);
                  setFileValidationStatus({
                    isValid: false,
                    message: "",
                    isChecked: false,
                  });
                }}
                style={{ padding: "4px" }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          )}

          <Tippy
            content={
              <span
                dangerouslySetInnerHTML={{
                  __html: t("centralUploads.instructions.tooltip_text_html"),
                }}
              />
            }
            theme="light"
            allowHTML={true}
            arrow={true}
          >
            <InfoIcon
              style={{ fontSize: "18px", color: "#666", cursor: "help" }}
            />
          </Tippy>
          <Tooltip title={t("centralUploads.actions.downloadTemplate")}>
            <Button
              justIcon
              size="sm"
              color="github"
              onClick={handleOpenDateModal}
            >
              <DownloadIcon />
            </Button>
          </Tooltip>
          <Tooltip title={t("centralUploads.actions.uploadFile")}>
            <Button
              justIcon
              size="sm"
              color={fileValidationStatus.isValid ? "success" : "client"}
              onClick={() => fileInputRef.current.click()}
            >
              <CloudUploadIcon />
            </Button>
          </Tooltip>
          <Tooltip
            title={
              fileValidationStatus.isValid
                ? t("centralUploads.actions.processFile")
                : fileValidationStatus.message ||
                  t("centralUploads.errors.file_not_validated")
            }
          >
            <span>
              <Button
                justIcon
                size="sm"
                color={
                  !uploadedFile
                    ? "default"
                    : fileValidationStatus.isValid
                      ? "warning"
                      : "danger"
                }
                className={cx({
                  [classes.attention]:
                    fileValidationStatus.isValid && !isProcessing,
                })}
                onClick={handleProcessFile}
                disabled={!fileValidationStatus.isValid || isProcessing}
              >
                {isProcessing || isValidating ? (
                  <ThreeDots color="#FFF" height={20} width={20} />
                ) : (
                  <SaveIcon />
                )}
              </Button>
            </span>
          </Tooltip>
        </Box>
      </div>
      {/* Container for status indicators - NOW MOVED TO THE RIGHT */}
      <div
        className={cx(classes.uploadStatusContainer, {
          [classes.uploadStatusVisible]: uploadedFile,
        })}
        style={{ justifyContent: "flex-end" }}
      >
        <div
          className={cx(classes.statusIndicator, {
            [classes.statusSuccess]: uploadedFile,
          })}
        >
          <CheckCircle fontSize="small" />
          <span>{t("centralUploads.status.file_uploaded")}</span>
        </div>
        <div
          className={cx(classes.statusIndicator, {
            [classes.statusSuccess]: fileValidationStatus.isValid,
            [classes.statusError]:
              !fileValidationStatus.isValid && fileValidationStatus.isChecked,
          })}
        >
          {isValidating ? (
            <ThreeDots color={clientColor} height={15} width={15} />
          ) : fileValidationStatus.isValid ? (
            <CheckCircle fontSize="small" />
          ) : (
            <ErrorOutline fontSize="small" />
          )}
          <span>
            {fileValidationStatus.message ||
              t("centralUploads.status.file_structure_pending")}
          </span>
        </div>
      </div>
    </>
  );

  const renderKpiBox = (kpi) => (
    <GridItem xs={12} sm={6} md={4} lg={3} key={kpi.id}>
      <div className={classes.kpiBox} onClick={() => handleKpiBoxClick(kpi)}>
        <AssessmentIcon className={classes.kpiBoxIcon} />
        <Typography className={classes.kpiTitleBox}>{kpi.title}</Typography>
      </div>
    </GridItem>
  );

  const renderCentralizedKpis = () => {
    const desiredOrder = ["topo", "financial", "budget"];

    const sortedSubtypes = Object.keys(kpiGroups.centralized || {}).sort(
      (a, b) => {
        const indexA = desiredOrder.indexOf(a);
        const indexB = desiredOrder.indexOf(b);
        if (indexA > -1 && indexB > -1) return indexA - indexB;
        if (indexA > -1) return -1;
        if (indexB > -1) return 1;
        return a.localeCompare(b);
      }
    );

    return (
      <>
        <GridItem xs={12}>{renderActionButtons()}</GridItem>
        {sortedSubtypes.map((subtype) => (
          <GridItem xs={12} key={subtype}>
            <h4 className={classes.sectionHeader}>
              {/* Agora apenas chama a função do escopo superior */}
              {getKpiSubtypeTranslation(t, subtype)}
            </h4>
            <GridContainer>
              {(kpiGroups.centralized[subtype] || []).map((kpi) =>
                renderKpiBox(kpi)
              )}
            </GridContainer>
          </GridItem>
        ))}
      </>
    );
  };

  const renderInitiativeKpis = () => {
    return (
      <>
        <GridItem xs={12}>{renderActionButtons()}</GridItem>
        <GridItem xs={12}>
          <GridContainer
            spacing={2}
            style={{ padding: "16px", backgroundColor: "#f9f9f9" }}
          >
            <GridItem xs={3}>
              <TextField
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {t("filters.search_initiative")}
                    <SearchIcon className={classes.searchIcon} />
                  </div>
                }
                size="small"
                classes={{ root: classes.textFieldRoot }}
                InputProps={{
                  classes: { input: classes.inputText },
                  style: { fontSize: "12px" },
                }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                  shrink: true,
                }}
                value={initiativeSearch}
                onChange={(e) => setInitiativeSearch(e.target.value)}
                style={{ width: "100%" }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    className={cx(
                      classes.tableHeadCell,
                      classes.stickyHeaderCell
                    )}
                  >
                    {t("centralUploads.table.initiative")}
                  </TableCell>
                  <TableCell
                    className={cx(
                      classes.tableHeadCell,
                      classes.stickyHeaderCellSecond
                    )}
                  >
                    {t("centralUploads.table.kpi")}
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    {t("centralUploads.table.kpi_type")}
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    {t("centralUploads.table.kpi_subtype")}
                  </TableCell>
                  {tableMonths.map((month) => (
                    <TableCell
                      key={month}
                      className={classes.tableHeadCell}
                      align="center"
                    >
                      {month}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredInitiativeData.map((row) => (
                  <TableRow key={row.initiative_kpi_id} hover>
                    <TableCell className={classes.stickyColumn}>
                      {row.initiative_name}
                    </TableCell>
                    <TableCell className={classes.stickyColumnSecond}>
                      {row.kpi_name}
                    </TableCell>
                    <TableCell>
                      {getKpiTypeTranslation(t, row.kpi_type)}
                    </TableCell>
                    <TableCell>
                      {getKpiSubtypeTranslation(t, row.kpi_subtype)}
                    </TableCell>
                    {tableMonths.map((month) => (
                      <TableCell
                        key={`${row.initiative_kpi_id}-${month}`}
                        className={classes.valueCell}
                      >
                        <div className={classes.valueInputContainer}>
                          <TextField
                            label={t("results_kpi.target")}
                            size="small"
                            type="number"
                            value={
                              initiativeValues[String(row.initiative_kpi_id)]?.[
                                month
                              ]?.target ?? ""
                            }
                            onChange={(e) =>
                              handleInitiativeTableCellChange(
                                row.initiative_kpi_id,
                                month,
                                "target",
                                e.target.value
                              )
                            }
                            classes={{ root: classes.textFieldRoot }}
                            InputProps={{
                              classes: { input: classes.inputText },
                            }}
                            InputLabelProps={{
                              classes: { root: classes.labelText },
                              shrink: true,
                            }}
                          />
                          <TextField
                            label={t("results_kpi.actual")}
                            size="small"
                            type="number"
                            value={
                              initiativeValues[String(row.initiative_kpi_id)]?.[
                                month
                              ]?.actual ?? ""
                            }
                            onChange={(e) =>
                              handleInitiativeTableCellChange(
                                row.initiative_kpi_id,
                                month,
                                "actual",
                                e.target.value
                              )
                            }
                            classes={{ root: classes.textFieldRoot }}
                            InputProps={{
                              classes: { input: classes.inputText },
                            }}
                            InputLabelProps={{
                              classes: { root: classes.labelText },
                              shrink: true,
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                            }}
                          >
                            <Button
                              justIcon
                              size="sm"
                              color="success"
                              onClick={() =>
                                handleSaveInitiativeMonthValue(
                                  row.initiative_kpi_id,
                                  month
                                )
                              }
                              style={{ height: "20px", width: "5px" }}
                            >
                              <SaveIcon fontSize="small" />
                            </Button>
                            <Button
                              justIcon
                              size="sm"
                              color="danger"
                              onClick={() =>
                                handleDeleteInitiativeMonthValue(
                                  row.initiative_kpi_id,
                                  month
                                )
                              }
                              style={{ height: "20px", width: "2px" }}
                            >
                              <DeleteIcon fontSize="small" />
                            </Button>
                          </div>
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </>
    );
  };


const renderImplementationPlanCard = () => {

  if (isLoading || !planData.configs || planData.configs.length === 0) {
    return null;
  }


  return (
    <Card>
      <CardHeader color="client" icon>
        <GridContainer justify="space-between" alignItems="center">
          <GridItem xs={12} sm={6}>
            <GridContainer alignItems="center">
              <CardIcon color="client">
                <Sort /> 
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("centralUploads.plan.title")}
              </h4>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CardHeader>
      <div style={{ padding: "15px" }}>
      <CardBody style={{ padding: 15 }}>
        <GridContainer>
          <GridItem xs={12}>
            {/* Action Buttons Bar - seguindo o padrão do primeiro card */}
            <div className={classes.actionButtonsBar}>
              <Typography variant="body2" style={{ color: grayColor[2] }}>
                {t("centralUploads.plan.description")}
              </Typography>

              {/* Action Buttons Group on the Right */}
              <Box display="flex" alignItems="center" gap="20px">
                {selectedPlanFile && (
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="body2"
                      className={classes.uploadedFileName}
                      title={selectedPlanFile.name}
                    >
                      {selectedPlanFile.name}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => setSelectedPlanFile(null)}
                      style={{ padding: "4px" }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}

                <Tippy
                  content={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("centralUploads.plan.tooltip_text_html"),
                      }}
                    />
                  }
                  theme="light"
                  allowHTML={true}
                  arrow={true}
                >
                  <InfoIcon
                    style={{ fontSize: "18px", color: "#666", cursor: "help" }}
                  />
                </Tippy>

                {planData.configs.map(config => (
                  <Tooltip key={config.id} title={t("centralUploads.actions.uploadFile") + ` (${config.name})`}>
                    <Button
                      justIcon
                      size="sm"
                      color="client"
                      onClick={() => {
                        if (planFileInputRef.current) {
                          planFileInputRef.current.click();
                        }
                      }}
                    >
                      <CloudUploadIcon />
                    </Button>
                  </Tooltip>
                ))}

                <Tooltip
                  title={
                    !selectedPlanFile
                      ? t("centralUploads.errors.no_file_selected")
                      : isPlanProcessing
                        ? t("centralUploads.messages.processing_file")
                        : t("centralUploads.actions.processFile")
                  }
                >
                  <span>
                    <Button
                      justIcon
                      size="sm"
                      color={
                        !selectedPlanFile
                          ? "default"
                          : isPlanProcessing
                            ? "warning"
                            : "success"
                      }
                      className={cx({
                        [classes.attention]: selectedPlanFile && !isPlanProcessing,
                      })}
                      onClick={() => handleProcessPlanFile(planData.configs[0])}
                      disabled={!selectedPlanFile || isPlanProcessing}
                    >
                      {isPlanProcessing ? (
                        <ThreeDots color="#FFF" height={20} width={20} />
                      ) : (
                        <SaveIcon />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </div>
          </GridItem>
          
          {/* Gantt Chart Display */}

          <GridItem xs={12} style={{ marginTop: 25 }}>
            {isLoading ? ( // Usamos o loader principal da página
               <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
                 <ThreeDots color={clientColor} />
               </div>
            ) : (
              // REQUISITO 3: Passa a lista global de iniciativas para o Gantt
              <InitiativesConsolidatedGantt
                initiatives={initiatives}
                classes={classes}
                t={t}
                userDetails={userDetails}
              />
            )}
          </GridItem>
        </GridContainer>
      </CardBody>
      </div>
    </Card>
  );
};


  // Error state - previne a tela branca
  if (hasError && !isLoading) {
    return (
      <div className={classes.root}>
        <Card>
          <CardBody style={{ padding: "50px", textAlign: "center" }}>
            <Typography variant="h5" style={{ marginBottom: "20px", color: "#f44336" }}>
              {t("centralUploads.errors.general_error_title") || "Erro ao carregar a página"}
            </Typography>
            <Typography variant="body1" style={{ marginBottom: "30px", color: "#666" }}>
              {errorMessage || t("centralUploads.errors.general_error_message") || "Ocorreu um erro inesperado. Tente recarregar a página."}
            </Typography>
            <Button 
              color="client" 
              onClick={() => window.location.reload()}
              style={{ marginRight: "10px" }}
            >
              {t("actions.refresh") || "Recarregar Página"}
            </Button>
            <Button 
              color="github" 
              onClick={() => {
                setHasError(false);
                setErrorMessage("");
                setIsLoading(true);
                // Força reload dos dados
                window.location.reload();
              }}
            >
              {t("actions.try_again") || "Tentar Novamente"}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }

  // Loading state
  if (isLoading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", padding: "50px" }}
      >
        <ThreeDots color={clientColor} />
      </div>
    );
  }

  // Try-catch para capturar erros de renderização que podem causar tela branca
  try {
    return (
      <div className={classes.root}>
        {/* Hidden file inputs - available regardless of conditions */}
        <input
          type="file"
          ref={planFileInputRef}
          style={{ display: "none" }}
          accept=".xlsx,.mpp"
          onChange={handlePlanFileSelect}
        />
        
        {/* Primeiro card só aparece se has_results_info for true */}
        {userDetails?.has_results_info && (
          <Card>
            <CardHeader color="client" icon>
              <GridContainer justify="space-between" alignItems="center">
                <GridItem xs={12} sm={6}>
                  <GridContainer alignItems="center">
                    <CardIcon color="client">
                      <CloudUploadIcon />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                      {t("centralUploads.title")}
                    </h4>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody style={{ padding: 15 }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                classes={{ root: classes.tabsRoot, indicator: classes.indicator }}
                variant="fullWidth"
              >
                <Tab
                  label={t("centralUploads.tabs.centralized")}
                  className={classes.tabRoot}
                />
                <Tab
                  label={t("centralUploads.tabs.byInitiative")}
                  className={classes.tabRoot}
                />
              </Tabs>

              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".xlsx"
                onChange={handleFileSelect}
              />

              <div style={{ padding: "15px" }}>
                <GridContainer>
                  {activeTab === 0 && renderCentralizedKpis()}
                  {activeTab === 1 && renderInitiativeKpis()}
                </GridContainer>
              </div>
            </CardBody>
          </Card>
        )}

        <GridContainer>
          <GridItem xs={12}>
            {renderImplementationPlanCard()}
          </GridItem>
        </GridContainer>

        <Dialog open={isDateModalOpen} onClose={handleCloseDateModal}>
          <DialogTitle>{t("centralUploads.dialog.select_period")}</DialogTitle>
          <DialogContent>
            <GridContainer spacing={2}>
              <GridItem xs={6}>
                <TextField
                  label={t("centralUploads.dialog.start_month")}
                  type="month"
                  value={dateRange.start}
                  onChange={(e) => handleDateRangeChange("start", e.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </GridItem>
              <GridItem xs={6}>
                <TextField
                  label={t("centralUploads.dialog.end_month")}
                  type="month"
                  value={dateRange.end}
                  onChange={(e) => handleDateRangeChange("end", e.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDateModal} color="github">
              {t("actions.cancel")}
            </Button>
            <Button onClick={handleDownloadTemplate} color="client">
              {t("actions.generate")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DRAWER FOR CENTRALIZED KPI EDITING */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={handleCloseDrawer}
          classes={{ paper: classes.drawerPaper }}
          BackdropProps={{
            style: { backgroundColor: "#000", opacity: "0.1" },
          }}
          PaperProps={{
            style: {
              borderRadius: "10px",
              margin: "1vh 1vh 1vh 0",
              height: "98vh",
            },
          }}
        >
          {selectedKpi && (
            <>
              <div className={classes.drawerHeader}>
                <Typography variant="h6">{selectedKpi?.title}</Typography>
                <IconButton onClick={handleCloseDrawer}>
                  <CloseIcon />
                </IconButton>
              </div>
              <div style={{ padding: "16px", overflowY: "auto" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "10px",
                  }}
                >
                  {/* 1. BOTÃO "ADD LINE" PADRONIZADO */}
                  <Tooltip title={t("results_kpi.add_line")}>
                    <Button
                      justIcon
                      size="sm"
                      color="client"
                      onClick={handleAddDrawerRow}
                    >
                      <AddCircle />
                    </Button>
                  </Tooltip>
                </div>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {/* 3. TEXTOS COM TRADUÇÃO */}
                        <TableCell>{t("results_kpi.time_period")}</TableCell>
                        <TableCell align="center">
                          {t("results_kpi.target")}
                        </TableCell>
                        <TableCell align="center">
                          {t("results_kpi.actual")}
                        </TableCell>
                        <TableCell align="center">{t("actions.title")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isDrawerLoading ? (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            style={{ padding: "16px 0", border: "none" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <ThreeDots color={clientColor} />
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : (
                        centralKpiRows.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>
                              <TextField
                                fullWidth
                                size="small"
                                type="month"
                                value={row.period}
                                disabled={!row.isNew}
                                onChange={(e) =>
                                  handleDrawerCellChange(
                                    row.id,
                                    "period",
                                    e.target.value
                                  )
                                }
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                fullWidth
                                size="small"
                                type="number"
                                value={row.target ?? ""}
                                onChange={(e) =>
                                  handleDrawerCellChange(
                                    row.id,
                                    "target",
                                    e.target.value
                                  )
                                }
                                classes={{ root: classes.textFieldRoot }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                fullWidth
                                size="small"
                                type="number"
                                value={row.actual ?? ""}
                                onChange={(e) =>
                                  handleDrawerCellChange(
                                    row.id,
                                    "actual",
                                    e.target.value
                                  )
                                }
                                classes={{ root: classes.textFieldRoot }}
                                InputProps={{
                                  classes: { input: classes.inputText },
                                }}
                                InputLabelProps={{
                                  classes: { root: classes.labelText },
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              {/* 2. BOTÕES DE AÇÃO PADRONIZADOS */}
                              <div className={classes.actionCell}>
                                <Tooltip title={t("actions.save")}>
                                  <Button
                                    justIcon
                                    size="sm"
                                    color="success"
                                    onClick={() => handleSaveDrawerRow(row)}
                                  >
                                    <SaveIcon />
                                  </Button>
                                </Tooltip>
                                <Tooltip title={t("actions.delete")}>
                                  <Button
                                    justIcon
                                    size="sm"
                                    color="danger"
                                    onClick={() => handleDeleteDrawerRow(row)}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </Tooltip>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </>
          )}
        </Drawer>
      </div>
    );
  } catch (renderError) {
    // Captura erros de renderização que podem causar tela branca
    console.error("[CentralUploads] Render error:", renderError);
    
    return (
      <div className={classes.root}>
        <Card>
          <CardBody style={{ padding: "50px", textAlign: "center" }}>
            <Typography variant="h5" style={{ marginBottom: "20px", color: "#f44336" }}>
              {t("centralUploads.errors.render_error_title") || "Erro de Renderização"}
            </Typography>
            <Typography variant="body1" style={{ marginBottom: "30px", color: "#666" }}>
              {t("centralUploads.errors.render_error_message") || "Ocorreu um erro ao renderizar a página. Por favor, recarregue a página."}
            </Typography>
            <Typography variant="body2" style={{ marginBottom: "30px", color: "#999", fontFamily: "monospace" }}>
              {renderError.message}
            </Typography>
            <Button 
              color="client" 
              onClick={() => window.location.reload()}
            >
              {t("actions.refresh") || "Recarregar Página"}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }
}
